import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IGetActiveModdatHayeBimehNameh from '../../Types/Queries/IGetActiveModdatHayeBimehNameh';

export const getActiveModdatHayeBimehNameh = createAsyncThunk(
  'InsuranceProductRule/getAllInsuranceProductRules',
  async (query: IGetActiveModdatHayeBimehNameh) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.ModdatBimehNameh.GetActiveModdatHayeBimehNameh}`,
      params: query,
    });
  }
);
